/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { BaseStorageKeys } from '@core/services/base-storage.service';
import { environment } from 'environments/environment';

const apiUrl = environment.baseUrl;
let coreApi = '';
let esApi = '';
let currentClusterReportingUrl = '';
let storageApiUrl = environment.storageApiUrl;
const mapsUrl = environment.mapsApiUrl;

export function getApiEndpoints(): any {
  const selectedCluster = localStorage.getItem(BaseStorageKeys.Cluster);

  if (selectedCluster) {
    const objSelectedCluster = JSON.parse(selectedCluster);

    coreApi = objSelectedCluster?.coreApiUrl;
    esApi = objSelectedCluster?.esApiUrl;
    currentClusterReportingUrl = objSelectedCluster?.reportingApiUrl;
    storageApiUrl = objSelectedCluster?.storageApiUrl;

    // Used when running project on localhost
    // coreApi = 'http://localhost:8080';
  }

  return {
    CORE_API: coreApi,
    ES_API: esApi,
    STORAGE_API: storageApiUrl,
    CONTRACT_AI_API: environment.contractAiApiUrl,
    SUPER_ADMIN_API: environment.superAdmin,
    CORE_API_SUPER_ADMIN: environment.baseUrl,

    API_ENDPOINT__AUTHENTICATE: `${apiUrl}/v2/login/username`,

    API_ENDPOINT__CLUSTERS: `${environment.superAdmin}/clusters`,

    // COMPANIES
    API_ENDPOINT__COMPANIES: `${coreApi}/companies`,

    // USERS
    API_ENDPOINT__USERS: `${coreApi}/users`,
    API_ENDPOINT__USERS_SEARCH: `${coreApi}/users/search`,
    API_ENDPOINT__USERS_OF_COMPANY: `${coreApi}/users/company`,

    // User Permission
    API_ENDPOINT__USER_PERMISSION: `${coreApi}/user-permission`,
    API_ENDPOINT__USER_PERMISSION_GROUPS: `${coreApi}/user-permission-group`,

    // Shipments
    API_ENDPOINT_SHIPMENTS: `${coreApi}/shipments`,

    /* PAYMENTS */
    API_ENDPOINT__PAYMENTS: `${coreApi}/payments`,

    // Forgot password
    API_ENDPOINT__FORGOT_PASSWORD: `${coreApi}/users/forgot-password`,

    // UTILS
    API_ENDPOINT__UTILS: `${coreApi}/utils`,

    /* QUICKBOOKS */
    API_ENDPOINT__QUICKBOOKS: `${coreApi}/quickbooks`,

    /* REPORTING */
    API_ENDPOINT__BOOKED_SHIPMENTS_FOR_CLIENT: `${currentClusterReportingUrl}/reports/companies/shipments_v2`,

    /* MAPS */
    API_ENDPOINT__MAPS_GEOCODE: `${mapsUrl}/geocode`,
  };
}
